import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cut_ic_arrow_right",
  "use": "icon-cut_ic_arrow_right-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14\" id=\"icon-cut_ic_arrow_right\"><path d=\"m1 1 6 6-6 6\" stroke=\"#979799\" stroke-width=\"2\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol